import { RefObject, useCallback, useEffect, useState } from 'react';

export const useElementMeasures = (
  className: string,
  dependency?: unknown,
  scopeRef?: RefObject<HTMLElement | null>,
): DOMRect => {
  const [measures, setMeasures] = useState<DOMRect>(new DOMRect());
  const scope = scopeRef?.current ?? document;
  const element = scope.querySelector(`.${className}`);

  const updateMeasures = useCallback(() => {
    const newMeasures = element?.getBoundingClientRect();
    if (!newMeasures) return;
    setMeasures(newMeasures);
  }, [element]);

  const handleResize = useCallback(() => {
    updateMeasures();
  }, [updateMeasures]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  useEffect(() => {
    if (!element) return;
    const observer = new ResizeObserver(updateMeasures);
    observer.observe(element);
    return () => observer.disconnect();
  }, [element, updateMeasures]);

  useEffect(() => {
    updateMeasures();
  }, [updateMeasures, dependency]);

  return measures;
};
